import * as React from "react";
import { forwardRef } from "react";
const ReactComponent = ({ title, titleId, ...props }, ref) => React.createElement("svg", { "data-testid": "markdown-list-number-17", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 17 17", ref: ref, "aria-labelledby": titleId, ...props },
    title ? React.createElement("title", { id: titleId }, title) : null,
    React.createElement("g", { fill: "none", stroke: "currentColor", strokeLinecap: "round" },
        React.createElement("path", { d: "M2.5 6.5h2" }),
        React.createElement("path", { strokeLinejoin: "round", d: "M2.572 11.651c.136-.396.453-.615.928-.649 1-.07 1.624 1.523 0 2.187-.684.28-1.018.717-1 1.311h2m-2-10.67 1-.83v3.5" }),
        React.createElement("path", { d: "M7.5 3.5h6m-6 5h6m-6 5h6" })));
const ForwardRef = forwardRef(ReactComponent);
export { ForwardRef as ReactComponent };
